
import { defineComponent, inject } from "vue";
import { centerCanvasViewPort, centerAndSizeScrollers } from "@/canvas-api/ViewPort";

export default defineComponent({
  name: "MobileHelpers",
  emits: ["toggleLock"],
  setup(_, { emit }) {
    const lockToolBar = inject<boolean>("lockToolBar", false);

    const handleToggleLock = () => {
      emit("toggleLock");
    };

    const handleCenterViewport = () => {
      centerCanvasViewPort();
      centerAndSizeScrollers();
    };
    return {
      lockToolBar,
      handleToggleLock,
      handleCenterViewport,
    };
  },
});
